<app-pcbread-crumb [data]="breadCrumb"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <div class="row pb-2 m-0">
    <div
      class="col-12 d-flex justify-content-sm-start align-items-sm-start justify-content-center align-items-center flex-wrap align-content-start p-0"
    >
      <h5 class="m-0 mobile-size">
        <span>{{ "BarcodeGenerator" | translate : "" }}</span>
      </h5>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-xs-6 col-md-4 col-sm-6 col-lg-4 d-flex justify-content-center">
      <div class="box-search-drug p-2 my-2 h-auto">
        <div class="row">
          <div class="col-12 mb-3">
            <div
              class="edit-form search-input-box"
              appClickOutside
              (clickOutside)="modalIsOpen = false"
            >
              <div class="validation-alert-sale-buy"></div>
              <label class="form-label" for="drugBrandName">
                {{ "ProductBrandName" | translate }}
              </label>

              <form [formGroup]="drugSearchForm">
                <div class="input-group input-box-search-advance">
                  <input
                    id="drugGenericCode"
                    type="text"
                    autocomplete="off"
                    class="form-control Focusable iner-Focusable search-input-box"
                    placeholder="{{ 'genericCode' | translate }}"
                    appSelectOnFocus
                    [(ngModel)]="barcodeUniqueData.drugGenericCode"
                    [ngModelOptions]="{ standalone: true }"
                    (keyup.Enter)="searchWithGenericCode()"
                    (keyup.escape)="modalIsOpen = false"
                  />
                  <input
                    id="drugBrandName"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    formControlName="drugBrandName"
                    class="form-control Focusable iner-Focusable search-input-box"
                    placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                    [(ngModel)]="barcodeUniqueData.drugName"
                    (keyup.escape)="modalIsOpen = false"
                  />
                </div>
              </form>
              <app-search-box
                [data]="searchData"
                [addButton]="true"
                [fields]="searchFields"
                [urlName]="'columnsArray_BuySearch'"
                [paging]="searchPaging"
                [modalIsOpen]="modalIsOpen"
                (parentAction)="parentSearchAction($event)"
              ></app-search-box>
            </div>
          </div>
          <div class="col-12 top-input-box mb-3">
            <label for="barcode-english-name" class="form-label m-0">
              {{ "BrandName" | translate }}:
            </label>
            <input
              id="barcode-english-name"
              type="text"
              disabled=""
              class="form-control ng-pristine ng-valid ng-touched"
              placeholder="xxxxxxxxxx"
              [(ngModel)]="barcodeUniqueData.drugEnglishName"
            />
          </div>
          <div class="col-12 top-input-box mb-3">
            <label for="barcode-companyName" class="form-label m-0">
              {{ "companyName" | translate }}:
            </label>
            <input
              id="barcode-companyName"
              type="text"
              disabled=""
              class="form-control ng-pristine ng-valid ng-touched"
              placeholder="xxxxxxxxxx"
              [(ngModel)]="barcodeUniqueData.companyName"
            />
          </div>
          <div class="col-12 top-input-box mb-3">
            <label for="barcode-country" class="form-label m-0">
              {{ "country" | translate }}:
            </label>
            <input
              id="barcode-country"
              type="text"
              disabled=""
              class="form-control ng-pristine ng-valid ng-touched"
              placeholder="xxxxxxxxxx"
              [(ngModel)]="barcodeUniqueData.country"
            />
          </div>
          <div class="col-12 top-input-box mb-3">
            <label for="barcode-drugPackageCount" class="form-label m-0">
              {{ "drugPackageCount" | translate }}:
            </label>
            <input
              id="barcode-drugPackageCount"
              type="text"
              disabled=""
              class="form-control ng-pristine ng-valid ng-touched"
              placeholder="xxxxxxxxxx"
              [(ngModel)]="barcodeUniqueData.drugPackageCount"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xs-6 col-md-4 col-sm-6 col-lg-4">
      <div
        class="form-check custom-option custom-option-basic my-2"
        [ngClass]="{ 'box-disabled': RadioButtonStatus != 'Unique' }"
      >
        <label
          class="form-check-label custom-option-content"
          for="customRadioTemp1"
        >
          <input
            name="customRadioTemp"
            class="form-check-input"
            type="radio"
            value="Unique"
            id="customRadioTemp1"
            [(ngModel)]="RadioButtonStatus"
            (change)="ChangeBarcode()"
          />
          <span class="custom-option-header">
            <span class="h6 mb-0">
              {{ "UniqueBarcode" | translate }}
            </span>
            <!-- <span>رایگان</span> -->
          </span>
          <span class="custom-option-body">
            <div class="col-12 top-input-box mt-3">
              <label for="barcode-expire-date" class="form-label m-0">
                {{ "ExpireDate" | translate }}:
              </label>
              <div class="validation-alert-sale-buy">
                <p></p>
              </div>
              <input
                id="barcode-expire-date"
                [appDisable]="RadioButtonStatus != 'Unique'"
                type="text"
                autocomplete="off"
                class="form-control ng-pristine ng-valid ng-touched"
                placeholder="xxxxxxxxxx"
                [(ngModel)]="barcodeUniqueData.EXP"
                (keyup)="ChangeBarcode()"
              />
            </div>
          </span>
        </label>
      </div>
      <div
        class="form-check custom-option custom-option-basic my-2"
        [ngClass]="{ 'box-disabled': RadioButtonStatus != 'Normal' }"
      >
        <label
          class="form-check-label custom-option-content"
          for="customRadioTemp2"
        >
          <input
            name="customRadioTemp"
            class="form-check-input"
            type="radio"
            value="Normal"
            id="customRadioTemp2"
            [(ngModel)]="RadioButtonStatus"
            (change)="ChangeBarcode()"
          />
          <span class="custom-option-header">
            <span class="h6 mb-0">
              {{ "GovernmentBarcode" | translate }}
            </span>
            <!-- <span>رایگان</span> -->
          </span>
          <span class="custom-option-body">
            <div class="col-12 top-input-box mt-3">
              <label for="barcode-Gtn" class="form-label m-0">
                {{ "GTN" | translate }}:
              </label>
              <div class="validation-alert-sale-buy">
                <p></p>
              </div>
              <input
                id="barcode-Gtn"
                type="text"
                [appDisable]="RadioButtonStatus != 'Normal'"
                autocomplete="off"
                class="form-control ng-pristine ng-valid ng-touched"
                placeholder="xxxxxxxxxx"
                [(ngModel)]="barcodeData.GTN"
                (keyup)="ChangeBarcode()"
              />
            </div>
            <div class="col-12 top-input-box mt-3">
              <label for="barcode-Uid" class="form-label m-0">
                {{ "Uid" | translate }}:
              </label>
              <div class="validation-alert-sale-buy">
                <p></p>
              </div>
              <input
                id="barcode-Uid"
                type="text"
                [appDisable]="RadioButtonStatus != 'Normal'"
                autocomplete="off"
                class="form-control ng-pristine ng-valid ng-touched"
                placeholder="xxxxxxxxxx"
                [(ngModel)]="barcodeData.UID"
                (keyup)="ChangeBarcode()"
              />
            </div>
            <div class="col-12 top-input-box mt-3">
              <label for="barcode-expire-date" class="form-label m-0">
                {{ "ExpireDate" | translate }}:
              </label>
              <div class="validation-alert-sale-buy">
                <p></p>
              </div>
              <input
                id="barcode-expire-date"
                type="text"
                [appDisable]="RadioButtonStatus != 'Normal'"
                autocomplete="off"
                class="form-control ng-pristine ng-valid ng-touched"
                placeholder="xxxxxxxxxx"
                [(ngModel)]="barcodeData.EXP"
                (keyup)="ChangeBarcode()"
              />
            </div>
            <div class="col-12 top-input-box mt-3">
              <label for="barcode-lot" class="form-label m-0">
                {{ "LOT" | translate }}:
              </label>
              <div class="validation-alert-sale-buy">
                <p></p>
              </div>
              <input
                id="barcode-lot"
                type="text"
                autocomplete="off"
                [appDisable]="RadioButtonStatus != 'Normal'"
                class="form-control ng-pristine ng-valid ng-touched"
                placeholder="xxxxxxxxxx"
                [(ngModel)]="barcodeData.LOT"
                (keyup)="ChangeBarcode()"
              />
            </div>
          </span>
        </label>
      </div>
    </div>
    <div class="col-12 col-xs-6 col-md-4 col-sm-6 col-lg-4 d-flex justify-content-center align-items-center flex-column"
    >
      <ng-container *ngIf="barcodeDataString != undefined">
        <div
          class="barcode-box d-flex justify-content-center align-items-center"
        >
          <app-datamatrix-barcode
            [BarcodeData]="barcodeDataString"
            [RenderImage]="exportBarcode"
          ></app-datamatrix-barcode>
        </div>
        <div class="d-flex justify-content-around align-items-center mt-4">
          <label for="count-int">
            {{ "Count" | translate }}
          </label>
          <input
            id="count-int"
            type="number"
            class="form-control w-25 "
            [(ngModel)]="printCount"
          />
          <button type="button" class="btn btn-outline-primary" (click)="print()">
            <i class="fas fa-print"></i>
            {{ "Print" | translate }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
